import { Button } from "@braintrust/braintrust-ui-components";

export const ReviewOfferButton = () => {
  return (
    <Button variant="positive" shape="squared" size="medium" type="submit">
      Review offer
    </Button>
  );
};
